class PositionType {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.name = data.name || null;
    this.name_l10n = data.name_l10n || [];
    this.clients_id = data.clients_id || null;
    this.active = data.active || null;
    this.rate = data.rate || null;
    this.display_order = data.display_order || null;
    this.access_portal = data.access_portal || null;
    this.recap_on_portal = data.recap_on_portal || null;
    this.code = data.code || null;
    this.media_on_portal = data.media_on_portal || null;
    this.ratings_on_portal = data.ratings_on_portal || null;
    this.view_documents_on_portal = data.view_documents_on_portal || null;
    this.auto_assign_new_staff = data.auto_assign_new_staff || null;
    this.claims_on_portal = data.claims_on_portal || null;
    this.claims_on_portal_others = data.claims_on_portal_others || null;
  }
}

export default PositionType;
